export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '北京世奥国际中心B座5层',
  uc_host: 'https://oem2026.xinmeibao.com',
  site_host: 'https://oem2026.xinmeibao.com',
  special_url: '/',
  site_title: '发稿云-软文精准营销平台',
  welcome_title: '发稿云 — 软文精准营销平台！',
  site_short_title: '发稿云',
  site_subtitle: '软文精准营销平台',
  company_name: '北京云猿科技有限公司',
  copyright: '© 2025 北京云猿科技有限公司',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/231031/17f02ee7412ec685767a8dbffb1d935b.jpg',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/231031/98f98a2e1ada99f0c17af15f7e574532.png',
  payment: '',
  qq: '19188233060',
  tel: '19188233060',
  company_account_id: '',
  company_bank: '',
  company_bank_name: '',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: '',
  section_id: 692781,
  belonger_id: 692781,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 